import React, { memo } from "react";
import { formatFullName } from "../../../lib";
import moment from "moment";

function CourseSchedulesTableRow({
  courseSchedule,
  onClickMarkAttendance,
  onViewDetails,
}) {
  const {
    campusName,
    isCompleted,
    isCurrent,
    isUpcoming,
    name: courseName,
    nextClassDate,
    numOfClassesCompleted,
    numOfClassesScheduled,
    numOfStudents,
    semester,
    shliachFirstName,
    shliachLastName,
    shluchaFirstName,
    year,
  } = courseSchedule;

  return (
    <div className="courses-schedules-table-row" onClick={onViewDetails}>
      <p>{courseName}</p>
      <div>
        <p className="fw-700">{campusName}</p>
        {shliachFirstName && (
          <p>{formatFullName(shliachFirstName, shliachLastName)}</p>
        )}
        {shluchaFirstName && (
          <p>{formatFullName(shluchaFirstName, shliachLastName)}</p>
        )}
      </div>
      <p>
        {semester} {year}
      </p>
      {/* if no nextClassDate, it can be bec it's completed, but if it's not completed, then it means it's bec it's TBD */}
      <p>
        {nextClassDate
          ? moment(nextClassDate).format("MM/DD/YYYY")
          : isCompleted
            ? ""
            : "TBD"}
      </p>
      <p>
        {numOfClassesCompleted}/{numOfClassesScheduled}
      </p>
      <p>{numOfStudents}</p>
      <p>
        {isCompleted
          ? "Completed"
          : isCurrent
            ? "Current"
            : isUpcoming
              ? "Upcoming"
              : ""}
      </p>
      <p>
        {numOfStudents > 0 && (
          <button
            className="btn-mark-attendance"
            onClick={(e) => {
              // Prevent click from bubbling up to the row's onViewDetails handler
              e.stopPropagation();
              onClickMarkAttendance();
            }}
          >
            <i className="material-icons mr-4">assignment</i>
            Mark Attendance
          </button>
        )}
      </p>
    </div>
  );
}

export default memo(CourseSchedulesTableRow);
